import styled from 'styled-components';
import { spacer8 } from '@spotify-internal/encore-foundation';
import Type from "../Type";
export default styled(Type.h1).attrs({
  variant: Type.heading4,
  weight: Type.black
}).withConfig({
  displayName: "Title",
  componentId: "g714y0-0"
})(["padding-bottom:", ";"], spacer8);